<template>
  <page :title="pageTitle" backTo="/marketing/sliders" :loading="slider === null" size="is-desktop">
    <div v-if="slider">
      <div class="columns">
        <div class="column is-4">
          <div class="box">
            <b-field label="Name">
              <b-input :value="slider.name" readonly></b-input>
            </b-field>

            <b-field label="Slug">
              <b-input :value="slider.key" readonly></b-input>
            </b-field>
          </div>
        </div>

        <div class="column">
          <div class="box">
            <div class="level">
              <div class="level-left">
                <p class="title is-5">Banner</p>
              </div>

              <div class="level-right">
                <a @click="add">Add</a>
              </div>
            </div>

            <b-table class="is-middle" v-sortable="sortableOptions" :data="slider.banners" detailed>
              <template slot-scope="props">
                <b-table-column custom-key="move">
                  <button class="button is-white drag-button" :banner-id="props.row.id">
                    <b-icon icon="cursor-move" size="is-small"></b-icon>
                  </button>
                </b-table-column>

                <b-table-column custom-key="name" :label="$tc('banner._name')+' '+$tc('name')">{{ props.row.name }}</b-table-column>

                <b-table-column :label="$tc('support_ticket.status._name')">
                  <strong>{{ props.row.status }}</strong>
                </b-table-column>

                <b-table-column custom-key="actions">
                  <div class="is-pulled-right">
                    <button class="button is-white" @click="remove(props.row)">
                      <b-icon icon="close" size="is-small"></b-icon>
                    </button>
                  </div>
                </b-table-column>
              </template>

              <template slot="detail" slot-scope="props">
                <edit-banner
                  :banner="props.row"
                  @updated="banner => props.row.status = banner.status"
                ></edit-banner>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>
  </page>
</template>

<script>
import EditBanner from "../components/EditBanner";

export default {
  components: {
    EditBanner
  },

  data() {
    return {
      sortableOptions: {
        chosenClass: "is-selected",
        handle: ".drag-button",
        onChange: event => {
          let bannerId = event.item
            .getElementsByClassName("drag-button")[0]
            .getAttribute("banner-id");

          let endpoint = `/admin/api/marketing/sliders/${this.$route.params.id}/banners/${bannerId}`;

          this.$http.put(endpoint, { order: event.newIndex });
        }
      },

      slider: null
    };
  },

  mounted() {
    this.load();
  },

  computed: {
    pageTitle() {
      return "Slider - " + this.$route.params.id;
    }
  },

  watch: {
    $route() {
      this.slider = null;

      this.load();
    }
  },

  methods: {
    load() {
      this.$http
        .get("/admin/api/marketing/sliders/" + this.$route.params.id)
        .then(response => {
          this.slider = response.data.data;
        });
    },

    add() {
      this.$http
        .post("/admin/api/marketing/sliders/" + this.slider.id + "/banners")
        .then(response => {
          this.slider.banners.push(response.data.data);
        });
    },

    remove(banner) {
      this.$http
        .delete(
          `/admin/api/marketing/sliders/${this.slider.id}/banners/${banner.id}`
        )
        .then(() => {
          let index = this.slider.banners.indexOf(banner);

          this.slider.banners.splice(index, 1);
        });
    }
  }
};
</script>
